// @flow
import * as actionTypes from './actionTypes';
import initialState from 'store/initialState';

export default function(state: any = initialState.selfCheckIn, action: any) {
  switch (action.type) {
    case actionTypes.SET_SELF_CHECK_IN_DATA:
      return action.payload;
    case actionTypes.SET_SCI_RESERVATION_ID:
      return {
        ...state,
        checkIn: { ...state.checkIn, reservationId: action.payload }
      };
    case actionTypes.SET_SCI_MILEAGE:
      return {
        ...state,
        checkIn: { ...state.checkIn, selfCheckinMileage: action.payload }
      };
    case actionTypes.SET_SCI_LICENSE_NUMBER:
      return {
        ...state,
        checkIn: { ...state.checkIn, licensePlate: action.payload }
      };
    case actionTypes.SET_SCI_CAR_COLOR:
      return {
        ...state,
        checkIn: { ...state.checkIn, vehicleColor: action.payload }
      };
    case actionTypes.SET_SCI_WAIT_STATE:
      return {
        ...state,
        checkIn: { ...state.checkIn, selfCheckinWaitState: action.payload }
      };
    case actionTypes.SET_SCI_MOBILE_NUMBER:
      return {
        ...state,
        checkIn: { ...state.checkIn, customerMobileNumber: action.payload }
      };
    case actionTypes.SET_SIGNATURE:
      return {
        ...state,
        checkIn: { ...state.checkIn, signatureImg: action.payload }
      };
    case actionTypes.SET_APPOINTMENT_NOTES:
      return {
        ...state,
        checkIn: { ...state.checkIn, appointmentNotes: action.payload }
      };
    case actionTypes.SET_SCI_SIGNED:
      return {
        ...state,
        checkIn: { ...state.checkIn, selfCheckinSigned: action.payload }
      };
    case actionTypes.SET_SCI_PERSON_ID:
      return {
        ...state,
        checkIn: { ...state.checkIn, personId: action.payload }
      };
    case actionTypes.SET_SELF_CHECKIN_STATUS:
      return {
        ...state,
        configFlow: { ...state.configFlow, selfCheckInStatus: action.payload }
      };
    case actionTypes.SET_STATUS_TRACKER_URL:
      return {
        ...state,
        configFlow: { ...state.configFlow, statusTrackerURL: action.payload }
      };
    case actionTypes.SET_SCI_IS_NAVIGATING:
      return {
        ...state,
        configFlow: { ...state.configFlow, isNavigating: action.payload }
      };
    case actionTypes.SET_SELF_CHECK_IN_FLOW:
      return {
        ...state,
        configFlow: { ...state.configFlow, selfCheckInFlow: action.payload }
      };
    case actionTypes.SET_IS_DEALER_OPEN_NOW:
      return {
        ...state,
        configFlow: { ...state.configFlow, isDealerOpenNow: action.payload }
      };
    case actionTypes.UPDATE_SCI_ADDITIONAL_SERVICES:
      return {
        ...state,
        configFlow: { ...state.configFlow, additionalServices: action.payload }
      };
    case actionTypes.UPDATE_SCI_ADDITIONAL_SERVICES_NOTES:
      return {
        ...state,
        configFlow: {
          ...state.configFlow,
          additionalServicesNotes: action.payload
        }
      };
    case actionTypes.SET_INITIAL_LOADING_COMPLETE:
      return {
        ...state,
        configFlow: {
          ...state.configFlow,
          initialLoadingComplete: action.payload
        }
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/selfCheckIn/reducer.js